/**
 * @author Javier Ojeda
 * @date 16/11/2018
 * @description: Actions relativas al modelo CountryLocal
 */

// @flow

import * as LocationActionTypes from 'action_types/LocationActionTypes';
import Dispatcher from 'dispatcher';
import ApiClient from 'utils/ApiClient';

class LocationActions {
  getCountries(): Promise<any> {
    return ApiClient.get({
      path: '/utilities/countries_iso3166.json',
      skipApiUrl: true,
      success: response => {
        Dispatcher.dispatch({
          type: LocationActionTypes.SAVE_COUNTRIES,
          countries: response['countries']
        });
      }
    });
  }

  getCountriesWithoutFlux() {
    return ApiClient.get({
      path: '/utilities/countries_iso3166.json',
      skipApiUrl: true
    });
  }

  getStatesByCountry(countryId: string, index?: number = ''): Promise<any> {
    return ApiClient.get({
      path: `/utilities/render_states_by_country?country_id=${countryId}`,
      skipApiUrl: true,
      success: response => {
        Dispatcher.dispatch({
          type: LocationActionTypes.SAVE_STATES_BY_COUNTRY,
          states: response['states'],
          index: index
        });
      }
    });
  }

  getStatesByCountryWithoutFlux(countryId: String) {
    return ApiClient.get({
      path: `/utilities/render_states_by_country?country_id=${countryId}`,
      skipApiUrl: true
    });
  }
}

export default new LocationActions();
